
IREP.ReferPromoBand = (function () {

    var init = function (emailCtrl, defaultEmailText) {

        var referDisplay = true;
        var referTarget = $('#ReferralHolder').offset().top;

        emailCtrl.focus(function () {
            if ($(this).val() == defaultEmailText) {
                $(this).val("");
                $(this).css('color', '#000000');
            }
        });
        emailCtrl.blur(function () {
            if ($(this).val() == '') {
                $(this).val(defaultEmailText);
                $(this).css('color', 'grey');
            }
        });

        var numRefs = $("#rpb").find(".referredRow");
        var newheight = 140 + (numRefs.size() * 25);
        //alert(newheight);
       // $("#rpb").find('.content').css("height", newheight);
        //$("#rpb").css("height", $("#rpb").find('.content').outerHeight() + $("#rpb").find('.header').outerHeight());


         

        if (emailCtrl.val() != defaultEmailText && !Page_IsValid) {

            $("#rpb").find('[data-actions~="band-toggle-footer"]').click();

            emailCtrl.css('color', '#000000');
            $(window).scrollTop($("#rpb").offset().top);
        }
          

        var interval = setInterval(function () {

            if ($(window).scrollTop() + $(window).height() > referTarget && referTarget + $('#existingReferrals').height() > $(window).scrollTop() && referDisplay) {
                referDisplay = false;
                TweenMax.to($("#ReferralHolder"), .15, { opacity: 1 })
                TweenMax.staggerFrom($(".referredRow"), .35, { rotationX: 360, opacity: 0, transformPerspective: 200, delay: .25 }, 0.45)
                //  TweenMax.staggerFromTo($(".referredRow"), 0.25, { rotationX: -90, opacity: 0 }, { rotationX: 0, opacity: 1, transformPerspective: 200, transformOrigin: "50% 0%", immediateRender: true }, 0.25)
                //   TweenMax.staggerFrom($('.referredRow'), .4, { x: 500, opacity: 0 }, .2);
                TweenMax.to($('#refer_people_bottom_bar'), 1.5, { opacity: 1 });
                TweenMax.from($('#refer_people_bottom_bar img.people_left'), 1.5, { left: "+=200px", opacity: 0, display: "none", delay: 1.15, ease: Back.easeOut });
                TweenMax.from($('#refer_people_bottom_bar img.people_right'), 1.5, { left: "-=200px", opacity: 0, display: "none", delay: 1.25, ease: Back.easeOut });
            }
        }, 250);



    }

    return {
        init: init
    };
})();